import { panelOpen } from "../store";
import { trackChatOpened } from "../tracking";
import { CHAT } from "./icons";

export function ChatTab() {
  if (panelOpen.value) return null;
  return (
    <button
      class="ic-tab"
      onClick={() => {
        panelOpen.value = true;
        trackChatOpened();
      }}
      aria-label="Åpne chat med Iskra"
    >
      {CHAT}
      <span class="ic-tab-label">Spør om badstu</span>
    </button>
  );
}
